import { logoHorizontal } from "@rageeb/frontend-lib";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { WarningCircleIcon } from "@/components/icons/warning-circle";

type MisconfiguredPageProps = {
	errors: string[];
};

/** Shown instead of the login redirect when `config.js` can't start the app. */
const MisconfiguredPage: FC<MisconfiguredPageProps> = ({ errors }) => {
	const { t } = useTranslation("common");

	return (
		<main className="flex min-h-screen items-center justify-center bg-background p-6">
			<div className="w-full max-w-xl rounded-xl bg-white p-8 shadow-sm">
				<img
					src={logoHorizontal}
					alt={t("misconfigured.logo_alt")}
					className="mb-8 h-8"
				/>
				<div className="mb-2 flex items-center gap-2">
					<WarningCircleIcon />
					<h1 className="text-xl font-semibold text-gray-1">
						{t("misconfigured.title")}
					</h1>
				</div>
				<p className="mb-4 text-sm text-gray-2">
					{t("misconfigured.description")}
				</p>
				<ul className="m-0 list-none rounded-lg bg-background p-4 font-mono text-xs text-gray-1">
					{errors.map((error) => (
						<li key={error}>{error}</li>
					))}
				</ul>
			</div>
		</main>
	);
};

export { MisconfiguredPage };
